import api from './api';
import {getToken} from '../utils/auth';

export const getMe = () =>
    api.get('/v2/users/me', {
        headers: {
            Authorization: getToken(),
        },
    });

export const getMeStore = () =>
    api.get('/me', {
        headers: {
            Authorization: getToken(),
        },
    });

export const userHasFarm = (currentUser) =>
    api.get(`/farm_users?users=${currentUser.id}`, {
        headers: {
            Authorization: getToken(),
        },
    });

export const getListFarmUser = async (userId, numPage) => {
    const aux00 = await api.get(`/farm_users?user=${userId}&page=${numPage}&perPage=30`, {
        headers: {
            Authorization: getToken(),
        },
    });

    return aux00.data['hydra:member'];
}
    

export const getListFarmUserSearchFarmName = async (userId, numPage, paramFarmName) => {
    const aux00 = await api.get(`/farm_users?user=${userId}&farm.name=${paramFarmName}&page=${numPage}&perPage=30`, {
        headers: {
            Authorization: getToken(),
        },
    });

    return aux00.data['hydra:member'];
}
    

export const forgotPasswordUser = (values) =>
    api.post(`/public/users/forgot_password`, values, {
    });

export const signUp = () =>
    api.post(`/public/users/sign_up`, { jwt: getToken() }, { headers: null});

export const verifyEmailExist = (email) =>
    api.post(`/public/users/verify_email_exist`, { email: email }, { headers: null });

export const accessFarmUser = (id) =>
    api.put(`/farm_users/${id}/access`, {}, {
        headers: {
            Authorization: getToken(),
        },
    });

    
export const loginIw = (values) =>
    api.post(`/users/login_iw`, values, {
        headers: {
            Authorization: getToken(),
        },
    });

export const changePassword = (values) =>
    api.post(`/users/change_password`, values, {
        headers: {
            Authorization: getToken(),
        },
    });